import { Box, Flex, Stack, Text } from '@mantine/core'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useTranslations } from 'next-intl'

import RichText from '@/app/[locale]/price/_components/Richtext'
import { createCoinsAiCardConverters } from '@/app/[locale]/price/[slug]/_components/NewsCommunity/CoinsAICard/richTextConverter'
import SparkleIcon from '@/assets/icons/sparkle.svg'
import { SummaryLexical } from '@/types/coin'

export default function CoinsAICard({ data, slug }: { data: SummaryLexical; slug: string }) {
  const t = useTranslations('newsCommunity')
  //const locale = useLocale()
  const pathname = usePathname()
  // Extract locale from pathname (e.g., "/en/price/bitcoin" -> "en")
  const locale = pathname.split('/')[1]

  return (
    <Link
      href={`/${locale}/coins-ai/${slug}/latest-news`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Flex
        direction="column"
        justify="center"
        h={240}
        w={190}
        style={{
          background: 'var(--bg-surface-secondary, #151D32)',
          borderRadius: 16,
          padding: 16,
          boxShadow: '0 2px 16px 0 rgba(16, 21, 34, 0.10)',
        }}
      >
        <Stack gap={4}>
          <Flex>
            <Text variant="body-emphasis">{t('coinsAINews')}</Text>
            <SparkleIcon width={20} height={20} />
          </Flex>
          <Box mb={4} h={163} style={{ overflow: 'hidden' }}>
            <Text component="div" variant="subtitle" c="var(--content-secondary)" lineClamp={9}>
              <RichText data={data} customConverters={createCoinsAiCardConverters()} />
            </Text>
          </Box>
          <Text component="div" variant="subtitle" c="var(--content-active)">
            {t('readLatestNews')}
          </Text>
          {/* block to render , margin bottom set to 4 */}
        </Stack>
      </Flex>
    </Link>
  )
}
